import { useParams } from 'react-router-dom';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { KMP_DEALER_NOMINATION } from 'features/common/acl/constants';
import CampaignSubsellerNominations from 'pages/CampaignSubsellerNominations/components/CampaignSubsellerNominations';

import PageLayout from '../components/PageLayout';

const CampaignSubsellerNominationsPage = () => {
	const { campaignId } = useParams();

	return (
		<PageLayout>
			<div className="Page-main">
				<AccessControl accessLevel={KMP_DEALER_NOMINATION} showAccessDenied>
					<CampaignSubsellerNominations campaignId={parseInt(campaignId)} />
				</AccessControl>
			</div>
		</PageLayout>
	);
};

export default CampaignSubsellerNominationsPage;
